import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import Login from './component/login'
import Home from './route/home'
import Faq from './route/faq'
import Region from './route/region'
import Country from './route/country'
import Group from './route/group'
import Course from './route/course'
import Players from './route/players'
import Discs from './route/discs'
import MyDiscs from './route/discs/MyDiscs'
import Bags from './route/discs/Bags'
import BagDetails from './route/discs/BagDetails'
import Brands from './route/discs/Brands'
import BrandDetails from './route/discs/BrandDetails'
import Games from './route/games'
import Scorecard from './route/games/scorecard'
import PrintableScorecard from './route/course/PrintableScorecard'
import PrivacyPolicy from './route/privacy'
import Dashboard from './route/admin'
import CourseManager from './route/admin/courses/manage'
import Curation from './route/admin/curation'
import Edits from './route/admin/edits'
import AdminGroup from './route/admin/group'
import RequireAdmin from './route/admin/RequireAdmin'
import Page from './component/page'
import store from './store'
import ScrollToTop from './ScrollToTop'
import { loadCourseGroups } from './store/actions'

function PageNotFound() {
  return (
    <Page>
      <h1>Page not found 404</h1>
    </Page>
  )
}

function App() {
  useEffect(() => {
    store.dispatch(loadCourseGroups())
  }, [])

  return (
    <Provider store={store}>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/faq" element={<Faq />} />
            <Route path="/region/:region" element={<Region />} />
            <Route path="/country/:country/:state?" element={<Country />} />
            <Route
              path="/course/:id/:courseId/print"
              element={<PrintableScorecard />}
            />
            <Route path="/course/:id/:courseId" element={<Course />} />
            <Route path="/course/:id" element={<Group />} />
            <Route path="/players" element={<Players />} />
            <Route path="/discs" element={<Discs />}>
              <Route index element={<MyDiscs />} />
              <Route path="bags" element={<Bags />} />
              <Route path="bags/:bagUuid" element={<BagDetails />} />
              <Route path="brands" element={<Brands />} />
              <Route path="brands/:brandKey" element={<BrandDetails />} />
            </Route>
            <Route path="/rounds/:gameId" element={<Scorecard />} />
            <Route path="/rounds" element={<Games />} />
            <Route path="/privacy/*" element={<PrivacyPolicy />} />
            <Route
              path="/admin"
              element={
                <RequireAdmin>
                  <Dashboard />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/courses/manage"
              element={
                <RequireAdmin>
                  <CourseManager />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/curation"
              element={
                <RequireAdmin>
                  <Curation />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/edits"
              element={
                <RequireAdmin>
                  <Edits />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/:groupId"
              element={
                <RequireAdmin>
                  <AdminGroup />
                </RequireAdmin>
              }
            />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </ScrollToTop>
        <Login />
      </Router>
    </Provider>
  )
}

export default App
